export default function DesignCard({ design, selected, onClick, handleType }) {
  const glId = design.id.replace(/TB$/, "GL");
  const imgSrc =
    handleType === "none"
      ? `/images/renders/gl/${glId}.png`
      : `/images/renders/tb/${design.id}.png`;

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-1.5 w-full"
    >
      <div
        className={`w-full aspect-square overflow-hidden border transition-colors ${
          selected
            ? "bg-gray-100 border-gray-900"
            : "bg-gray-50 border-transparent hover:border-gray-300"
        }`}
      >
        <img
          src={imgSrc}
          alt=""
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.hidden = true;
          }}
        />
      </div>
      <span className="text-xs text-gray-600 text-center leading-tight">
        {design.size}LM
      </span>
    </button>
  );
}
